import { Component } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { services } from '../../services';
import { ActivatedRoute, Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { TranslationService } from '../../../../../../shared/services/translations.service';

@Component({
  selector: 'app-wild-rift-normal-games',
  templateUrl: './wild-rift-normal-games.component.html'
})
export class WildRiftNormalGamesComponent {
  service = 'normalgames';
  availableServices = services['wild-rift'].filter(service => service.service !== this.service);

  serviceParams = {
    game: 'wild-rift',
    service: 'normalgames',
    type: 'solo',
    queue: 'unranked',
    title: {
      en: 'Normal Wins',
    },
    subtitle: {
      en: 'Guaranteed Unranked Wins in Solo or Duo Boosting',
      fr: 'Victoires non classées garanties en Solo ou Duo Boosting',
      de: 'Garantierte ungewertete Siege im Solo- oder Duo-Boosting',
      pt: 'Vitórias Unranked garantidas em Solo ou Duo Boosting',
      es: 'Victorias no clasificadas garantizadas en Solo o Duo Boosting',
    },
    start: 9,
    desired: 10,
    serviceName: {
      en: 'Wins',
      fr: 'Victoires',
      de: 'Siege',
      pt: 'Wins',
      es: 'Wins',
    },
    min: 1,
    max: 10
  }

  serviceFaqs = {
    en: [
      {
        question: "What Is A Normal Win Boosting Service?",
        answer: "Normal Wins are an unranked service that guarantees a predetermined amount of unranked victories."
      },
      {
        question: "In Which Game Mode Are Normal Wins Played?",
        answer: "Normal Wins can be played in Unranked and ARAM."
      },
      {
        question: "Do Losses Count Towards Order Progression?",
        answer: "Only wins are counted, therefore when you purchase 10 Normal Wins, you are guaranteed to have played at least 10 games."
      },
      {
        question: "Can I Use This Service To Secure The First Win Of The Day Or Event Pass Levels?",
        answer: "Yes, you can. As long as the service is active we will try to complete as many missions as possible."
      },
      {
        question: "Can I Play With The Booster In Duo Queue Boosting?",
        answer: "Indeed, you can. To accomplish this, go to the order customization menu and select 'Duo' before clicking 'Buy Boost Now.'"
      },
      {
        question: "Can I Choose My Preferred Champions/Roles And Summoner Spell Order?",
        answer: "Yes, you can. Click the 'Choose your Roles' and 'Choose your Champions' options in the order customization menu to make it happen."
      }
    ],
    fr: [
      {
        question: "Qu\'est-ce qu\'un service de Boosting Normal?",
        answer: "Les victoires normales sont un service non classé qui garantit un nombre prédéterminé de victoires non classées."
      },
      {
        question: "Dans quel mode de jeu les victoires normales sont-elles jouées ?",
        answer: "Les victoires normales peuvent être jouées en Unranked ou ARAM."
      },
      {
        question: "Les défaites sont-elles prises en compte dans la progression des commandes?",
        answer: "Seuls les victoires sont prises en compte. Par conséquent, lorsque vous achetez 10 victoires normales, vous avez la garantie d\'avoir joué au moins 10 parties."
      },
      {
        question: "Puis-je utiliser ce service pour garantir la première victoire de la journée ou les niveaux de passe d\'événement?",
        answer: "Oui, c\'est possible. Tant que le service est actif, nous nous efforcerons d\'accomplir autant de missions que possible."
      },
      {
        question: "Puis-je jouer avec le Booster en Boosting Duo?",
        answer: "En effet, vous pouvez le faire. Pour ce faire, allez dans le menu de personnalisation de la commande et sélectionnez \"Duo\" avant de cliquer sur \"Acheter Boost maintenant\"."
      },
      {
        question: "Puis-je choisir mes champions/rôles préférés et l\'ordre des sorts d\'invocateur?",
        answer: "Oui, vous le pouvez. Cliquez sur les boutons 'Choisissez vos Rôles' et 'Choisissez votre Champion' dans le menu de personnalisation de la commande pour le faire."
      }
    ],
    de: [
      {
        question: "Was ist ein Normal Win Boosting Service?",
        answer: "Bei den Normal Wins handelt es sich um einen Dienst ohne Rangliste, der eine bestimmte Anzahl von Siegen ohne Rangliste garantiert."
      },
      {
        question: "In welchem Spielmodus werden Normal Wins gespielt?",
        answer: "Normale Siege können entweder in Unranked oder ARAM gespielt werden."
      },
      {
        question: "Zählen Verluste für den Bestellungsfortschritt?",
        answer: "Es werden nur Gewinne gezählt. Wenn du also 10 normale Gewinne kaufst, hast du garantiert mindestens 10 Spiele gespielt."
      },
      {
        question: "Kann ich diesen Service nutzen, um mir den ersten Gewinn des Tages oder die Eventpass-Stufen zu sichern?",
        answer: "Ja, das kannst du. Solange der Dienst aktiv ist, werden wir versuchen, so viele Missionen wie möglich zu erfüllen."
      },
      {
        question: "Kann ich mit dem Booster im Duo Queue Boosting spielen?",
        answer: "Ja, das kannst du. Gehe dazu in das Menü zur Bestellungsanpassung und wähle \"Duo\" aus, bevor du auf \"Boost Jetzt Kaufen\" klickst.",
      },
      {
        question: "Kann ich meine bevorzugten Champions/Rollen und die Reihenfolge der Beschwörerzauber wählen?",
        answer: "Ja, das können Sie. Klicken Sie auf die Schaltflächen 'Wähle deine Rollen' und 'Wähle deinen Champion' im Bestell-Anpassungsmenü, um es zu tun."
      }
    ],
    pt: [
      {
        question: "O Que É Um Serviço De Normal Wins Boosting?",
        answer: "Normal Wins é um serviço exclusivo para jogos não ranked que garante uma quantidade predeterminada de vitórias."
      },
      {
        question: "Em qual modo de jogo as Normal Wins são jogadas?",
        answer: "As Normal Wins podem ser jogadas em Unranked e ARAM."
      },
      {
        question: "As Derrotas Contam Para O Progresso Do Serviço?",
        answer: "Apenas vitórias são contadas, portanto, quando compras 10 Normal Wins, está garantido teres pelo menos 10 jogos."
      },
      {
        question: "Posso usar este serviço para garantir a primeira vitória do dia ou níveis de event pass?",
        answer: "Sim, podes. Enquanto o serviço estiver ativo, tentaremos completar o máximo de missões possíveis."
      },
      {
        question: "Posso Jogar com o Booster em Duo Queue?",
        answer: "Sim, podes. Para isso basta falares e agendares com o teu booster no chat do serviço."
      },
      {
        question: "Posso escolher meus champions/roles preferidos e a ordem dos Summoner Spells?",
        answer: "Sim, podes. Cliqua nos botões 'Escolhe os teus Roles' e 'Escolhe os teus Champions' no menu de personalização do pedido para fazer isso."
      }
    ],
    es: [
      {
        question: "¿Qué es un servicio de Boost Normal Win?",
        answer: "Las Normal Wins son un servicio sin clasificación que garantiza una cantidad predeterminada de victorias sin clasificación."
      },
      {
        question: "¿En qué modo de juego se juegan las Normal Wins?",
        answer: "Las victorias normales se pueden jugar en Uranked e ARAM."
      },
      {
        question: "¿Cuentan las pérdidas para la progresión de la orden?",
        answer: "Sólo se cuentan las victorias, por lo tanto, al comprar 10 Normal Wins , se le garantiza haber jugado al menos 10 partidas."
      },
      {
        question: "¿Puedo utilizar este servicio para asegurar la primera victoria del día o los niveles de abono para eventos?",
        answer: "Sí, es posible. Mientras el servicio esté activo intentaremos completar el mayor número posible de misiones."
      },
      {
        question: "¿Puedo jugar con los boosters en Duo Queue Boosting?",
        answer: "Efectivamente, puedes hacerlo. Para ello, ve al menú de personalización del pedido y selecciona \"Duo\" antes de hacer clic en \"Comprar Boost ahora\"."
      },
      {
        question: "¿Puedo elegir mis campeones/roles preferidos y el orden de los hechizos de invocador?",
        answer: "Sí, puedes. Haz clic en los botones 'Elige tus Roles' y 'Elige tu Campeón' en el menú de personalización del pedido para hacerlo."
      }
    ]
  }


  private page = {
    title: {
      en: "Wild-Rift Boost - Normal Wins Boosting for Wild-Rift",
      fr: "Boost Wild-Rift - Boosting de Victoire Normale sur Wild-Rift",
      de: "Wild-Rift Boost - Normal Wins Boosting für Wild-Rift",
      pt: "Wild-Rift Boost - Boost de Normal Wins para Wild-Rift",
      es: "Wild-Rift Boost - Boost de Normal Wins para Wild-Rift",
    },
    metaDescription: {
      en: "Looking to improve your normal game MMR in Wild-Rift? Our affordable, fast, and secure service will help you queue against better players!",
      fr: "Vous cherchez à améliorer votre MMR en partie normale sur Wild-Rift ? Notre service abordable, rapide et sécurisé vous permettra d\'affronter de meilleurs joueurs!",
      de: "Du möchtest deine MMR verbessern, indem du dich mit anderen Spielern in Wild-Rift triffst? Wir helfen dir dabei, dich mit besseren Spielern zu messen - kostengünstig, schnell und sicher!",
      pt: "Procurando melhorar o teu MMR de normal wins no Wild-Rift? O nosso serviço acessível, rápido e seguro ajudar-te-á a enfrentar jogadores melhores!",
      es: "¿Quieres mejorar tu MMR de juego normal en Wild-Rift? ¡Nuestro servicio asequible, rápido y seguro te ayudará a hacer cola contra mejores jugadores!",
    }
  }

  lang: string = 'en';

  constructor(meta: Meta, title: Title, private route: ActivatedRoute, private router: Router, private cookie: CookieService, private translationService: TranslationService,) {
    this.route.params.subscribe(params => {
      if (Object.keys(params).length === 0) {
        const url = this.router.url.split('/');
        if (this.translationService.validLangs.includes(url[1])) {
          this.lang = url[1];
        } else {
          this.lang = this.cookie.get('gg-lang') || 'en';
        }
      } else {
        this.lang = params['lang'] || 'en';
      }

      title.setTitle(this.page.title[this.lang] || this.page.title['en']);
      meta.updateTag(
        {
          name: 'description',
          content: this.page.metaDescription[this.lang] || this.page.metaDescription['en']
        }
      );
    });
  }
}